export default {
  maxFrets: 30,
  maxStrings: 20
}
